import RestAPI from "@aws-amplify/api-rest";
import { validateEmail50, validateOptional50, validateSomething, validateString50, validateString75 } from "../../Form/Validations";
import { toast } from "react-toastify";


export class SelfManaged {

    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, paises) {
        return {
            visible: true,
            nombre_servicio: data.nombre_servicio,
            data: {},
            activeStep: 0,
            resolveBody: (values, props) => {
                return {
                    url: `/farms/${props.farmId}/integrador/crearIntegrador`,
                    body: {...values,
                        direccion: `${values.direccion_compania ?? ""}, ${values.ciudad ?? ""}, ${values.estado ?? ""}`,
                        representante :`${values.nombre_admin} ${values.apellido_paterno_admin}` + (values.apellido_materno_admin !== null ? ` ${values.apellido_materno_admin}` : "")
                    },
                    buy_seat: props.dialogState.data?.buy_seat === "seat"
                };
            },
            steps: [
                {
                    label: t("accounts.emailContact"),
                    inputs: [{ label: t("accounts.emailContact"), campo: "email", component: "text" }],
                    validateFunction: this.validateContactEmail,
                },
                {
                    label: t("sass.conectar"),
                    validateFunction: this.validateSelfManage,
                    inputs: [
                        {
                            label: t("sass.form.nombre_compañia"),
                            campo: "nombre_compania",
                            component: "text",
                            validation: validateString50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.direccion"),
                            campo: "direccion_compania",
                            component: "text",
                            validation: validateSomething,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.ciudad"),
                            campo: "ciudad",
                            component: "text",
                            validation: validateSomething,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.estado"),
                            campo: "estado",
                            component: "text",
                            validation: validateSomething,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.pais"),
                            campo: "tipo_pais_id",
                            component: "select",
                            validation: validateSomething,
                            allowNoEdit: true,
                            options: paises,
                            optionLabel: "descripcion",
                            optionKey: "tipo_pais_id",
                        },
                        {
                            label: t("sass.form.contacto_administrativo"),
                            component: "divider",
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.nombre"),
                            campo: "nombre_admin",
                            component: "text",
                            validation: validateString50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.apellido_paterno"),
                            campo: "apellido_paterno_admin",
                            component: "text",
                            validation: validateString50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.apellido_materno"),
                            campo: "apellido_materno_admin",
                            component: "text",
                            validation: validateOptional50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.email"),
                            campo: "email_admin",
                            component: "text",
                            validation: validateEmail50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.contacto_tecnico"),
                            component: "divider",
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.nombre"),
                            campo: "nombre_tec",
                            component: "text",
                            validation: validateString50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.apellido_paterno"),
                            campo: "apellido_paterno_tec",
                            component: "text",
                            validation: validateString50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.apellido_materno"),
                            campo: "apellido_materno_tec",
                            component: "text",
                            validation: validateOptional50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.email"),
                            campo: "email_tec",
                            component: "text",
                            validation: validateEmail50,
                            allowNoEdit: true,
                        },
                        {
                            label: t("sass.form.acceso"),
                            campo: "tipousuario_id",
                            component: "select",
                            validation: validateSomething,
                            allowNoEdit: false,
                            options: [{ label: t("sass.tipoUsuario.5"), value: 5 }, { label: t("sass.tipoUsuario.26"), value: 26 }, { label: t("sass.tipoUsuario.34"), value: 34 }],
                        },
                        {
                            campo: "distribuidor_id",
                        },
                        {
                            component: "error",
                            errorKey: "emailNotMatch"
                        },
                    ],
                },
            ],
        };
    }

    static async validateContactEmail(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;

        const errors = {};
        try {
            if (values) {
                const er = validateEmail50(values.email);
                if (er !== undefined) {
                    errors.email = er;
                    return errors;
                }
                if (isSubmitting){
                    props.setForceLoading(true);
                    // await new Promise(r => setTimeout(r, 1000))
                    const endpoint = `/farms/${props.farmId}/integrador/checkIntegrador`;
                    const response = await RestAPI.post("apiAdminDropControl", endpoint, { body: { email: values.email } });
                    if (response.denied){
                        errors.email = "validation.invalidEmail";
                    }
                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            ...s.data,
                            nombre_compania: response.data?.distribuidor_id ? response.data.nombre : null,
                            tipo_pais_id: response.data?.tipo_pais_id ?? null,
                            email_admin: response.data?.email_admin ?? null,
                            email_tec: response.data?.email_tecnico ?? null,
                            distribuidor_id: response.data?.distribuidor_id ?? null,
                            verifiedEmail: values.email
                        }
                    }));
                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            toast.error(props.t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            errors.unknown = error.message;
            props.setForceLoading(false);
            return errors;
        }
    }

    static async validateSelfManage(data, props) {
        const errors = {};
        if (data) {
            // if no integrator, validate all fields
            if (!data.distribuidor_id){
                for (const field of Object.keys(data)) {
                    if (field === "distribuidor_id") continue;
                    if (field === "email_tec" || field === "email_admin") {
                        const er = validateEmail50(data[field]);
                        if (er !== undefined) errors[field] = er;
                    } else if (field.includes("nombre") || field.includes("apellido_paterno")) {
                        const er = validateString50(data[field]);
                        if (er !== undefined) errors[field] = er;
                    } else if (field.includes("apellido_materno")) {
                        const er = validateOptional50(data[field]);
                        if (er !== undefined) errors[field] = er;
                    } else {
                        const er = validateSomething(data[field]);
                        if (er !== undefined) errors[field] = er;
                    }
                }
                const direccion = (data.direccion_compania !== null ? data.direccion_compania : "") +
                  (data.ciudad !== null ? `, ${data.ciudad}` : "") +
                  (data.estado !== null ? `, ${data.estado}` : "");
                const er = validateString75(direccion);
                if (er !== undefined) errors.direccion = er;
                // check if email match with the one in the first form
                if (props.innerRef.current.isSubmitting && (props.dialogState.data.verifiedEmail !== data.email_tec && props.dialogState.data.verifiedEmail !== data.email_admin)){
                    errors.emailNotMatch = "sass.form.errorEmailNoMatch";
                }
            } else {
                // if integrator, validate only access
                const er = validateSomething(data.tipousuario_id);
                if (er !== undefined) errors.tipousuario_id = er;
            }
        }
        return errors;
    }

    /**
   * @returns {import("../types").DialogState}
  */
    static updateAPIAccess(t, data) {
        const distribuidorId = data.connection_data?.distribuidor_id;
        const usuarioApi = data.connection_data?.usuario_id;
        return {
            visible: true,
            activeStep: 0,
            nombre_servicio: data.nombre_servicio,
            tipousuario_api_permitido: [5],
            data: {
                distribuidor_id: distribuidorId,
                tipousuario_id: data.connection_data?.tipousuario_id
            },
            oldData: {
                tipousuario_id: data.connection_data?.tipousuario_id,
            },
            skipCostStep: true,
            skipReviewStep: true,
            hideStepper: true,
            confirmButtonLabel: t("general.confirm"),
            resolveBody: (values, props) => {
                return {
                    url: `/farms/${props.farmId}/integrador/${distribuidorId}/updatePermiso/${usuarioApi}`,
                    body: {
                        tipousuario_id: values.tipousuario_id
                    }
                };
            },
            steps: [
                {
                    label: t("forms.update"),
                    inputs: [
                        {
                            label: t("sass.acceso"),
                            campo: "tipousuario_id",
                            options: [{ label: t("sass.tipoUsuario.5"), value: 5 }, { label: t("sass.tipoUsuario.26"), value: 26 }, { label: t("sass.tipoUsuario.34"), value: 34 }],
                            validation: validateSomething,
                            component: "select",
                        },
                    ],
                },
            ],
        };
    }
}
